<template>
    <div v-show="this.$route.path.indexOf('/programmes/videoing') === -1">
        <!-- 这里是无用导航 会和导航一样变化 使得其他模块看得见导航 -->
        <el-menu style="z-index: 101;" :router="true" :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
          <el-menu-item index="/">
            <div> <a href="/"> <img width="100px" height="52px" src="../../assets/Logo/Logo3.jpg" alt="这个是ALlogo"> </a> </div>
          </el-menu-item>
        </el-menu>
        <el-menu style="z-index: 101; position: fixed; width: 100%; top: 0;" :router="true" :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
          <el-menu-item index="/">
            <div> <a href="/"> <img width="100px" height="52px" src="../../assets/Logo/Logo3.jpg" alt="这个是ALlogo"> </a> </div>
          </el-menu-item>
          <el-menu-item style="font-size:15px" index="/function">首页</el-menu-item>
          <el-menu-item style="font-size:15px" index="/question">题库</el-menu-item>
          <el-menu-item style="font-size:15px" index="/sweepstakes">竞赛</el-menu-item>
          <el-menu-item style="font-size:15px" index="/homepage">讨论区</el-menu-item>
          
          
          <el-menu-item v-if="this.$store.state.me.is_login" style="float: right;">
            <!-- <el-dropdown>
              <div class="el-dropdown-link" slot="reference">
                <img :src="this.$store.state.me.photo" width="40px" height="40px" class="rounded-circle">
                <i class="el-icon-arrow-down el-icon--right"></i>
              </div>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item> <span @click="UpdateInfo">个人信息</span></el-dropdown-item>
                <el-dropdown-item> <span @click.prevent="OutLogin">退出登录</span></el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown> -->
            <el-popover
              placement="top-start"
              width="150"
              trigger="hover"
              content="这是一段内容,这是一段内容,这是一段内容,这是一段内容。">
              <div class="hoverhover" style="padding: 4px; cursor: pointer; text-align: center;" @click="UpdateInfo">个人信息</div>
              <div class="hoverhover" style="padding: 4px; cursor: pointer; text-align: center; margin-top: 10px;" @click.prevent="OutLogin">退出登录</div>

              <div class="el-dropdown-link" slot="reference">
                <img :src="this.$store.state.me.photo" width="40px" height="40px" class="rounded-circle">
                <i class="el-icon-arrow-down el-icon--right"></i>
              </div>
            </el-popover>
          </el-menu-item>
         
          <el-menu-item  v-if="!this.$store.state.me.is_login" index="/Login" style="float: right; font-size: 15px;">
            登录&nbsp;/&nbsp;注册
          </el-menu-item>

          <el-menu-item style="float: right;">
            <img src="../../assets/Logo/160053nNVENL8EF2zYKUfe.png" alt="图标" 
            height="40px"
            width="40px"
            style="margin-right: 20px; margin-top: 10px;"
            v-show="!this.isdianji" id="main" @click="dianji">
          </el-menu-item>
        </el-menu>

        <div id="friends" class="ma">
        <transition
            name="animate__animated animate__bounce"
            enter-active-class="animate__bounceInRight"
            leave-active-class="animate__bounceOutUp"
        >
            <!-- 加上v-drag 使得其自定义可拖动指令可以使用 -->
            <div v-drag v-if="isdianji" class="chat_window1" :style="{ top: `${Top}`, right: `${Right}` }">
                <div class="al-chat header">
                    <div class="pull-left fs-gui-window-heading-icon">
                        <img class="fs-gui-window-heading-icon-img" src="
                        https://cdn.acwing.com/media/file_system/file/application/icon/2220490481555590627-128_UQONKkk.png
                        " alt="图标" height="23px"
                        >
                    </div>
                    <div style="margin-left: 10px; width:120px" class="pull-left fs-gui-window-heading-title">
                        <span >
                            AL Chat
                        </span>
                    </div>
                    <button @click="dianji" class="pull-right btn btn-link fs-gui-window-heading-btn fs-gui-window-heading-btn-close" title="关闭" style="margin-left:713px">
                      <img class="img-responsive" width="20px" src="https://cdn.acwing.com/static/web/img/file_system/gui/window/button/close.png" alt="关闭">
                    </button>
                </div>
                <div style="margin-top:40px; width:100%; height:calc(100% - 5px); display: flex; float:left;">
                <!-- 头像 名字 和 在线信息 -->
                <div style="width:250px; height:calc(100% - 35px); background-color: #E9F0F3;">
                    <div style=" width:250px; height:56px; display: flex; float:left; border-style:solid; border-width:1px; border-color : lightgrey">
                    <!-- 头像位置 -->
                    <div><img :src="this.$store.state.me.photo" width="50px" height="50px" style="border-radius: 50%; margin-left: 10px;" alt="这个是头像"></div>
                        <div style="width: 200px; height: 50px; margin-left: 10px; font-size:20px">
                        <!-- 名字 -->
                        <div style="width: 150px; height: 24px;">{{this.$store.state.me.name}}</div>
                            <div style="width: 150px; height: 20px; font-size:16px">
                            <div style="display: flex; float:left;">
                                <!-- 在线信息 -->
                                <i @click="dianwo" class="el-icon-coffee-cup" style="margin-top: 4px;" :style="{color}"></i>
                                <div style="margin-left:2px">{{str}}</div>
                            </div>
                            </div>
                        </div>
                    </div>
                    <!-- 搜索框 -->
                    <div style="margin-left: 10px;">
                        <el-input
                            style="width:180px; margin-top: 10px;"
                            placeholder="请输入内容"
                            v-model="input"
                            clearable
                            @keyup.native.enter="handleEnter"
                            >
                        </el-input>
                        <i @click="openSearch = true" class="el-icon-plus" style="margin-left: 20px; font-size: 20px; line-height: normal;"></i>
                    </div>
                    <hr>
                    <!-- 好友栏 -->
                    <div style="width: 240px; height: 290px; overflow: auto;">
                        <div @click="dianwol(f)" @contextmenu.prevent="showContextMenu($event, f.id)" v-for="f in friends" :key="f.id">
                            <div class="friendslan" style="width:222px; height:56px; display: flex; float:left; border-style:solid; border-width:1px; border-color : lightgrey;">
                                <div>
                                    <img :src="f.photo" width="40px" height="40px" style="border-radius: 50%; margin-top: 7px; margin-left: 10px; margin-bottom: 12px;" alt="这个是头像"></div>
                                    <div style="width: 200px; height: 40px; font-size:20px">
                            
                                    <div style="width: 150px; height: 24px; margin-top: 12px; margin-left: 5px; color: #212529;">{{ f.name }}</div>
                                </div>
                            </div>
                            
                        </div>
                        
                    </div>
                </div>
                <!-- 聊天框 -->
                <div style=" width:650px; height:calc(100% - 35px); background-color: white;"> <!-- 这里是聊天框 -->
                    <chat ref="SonComponent" :info="info"></chat>
                </div>
                </div>
            </div>
        </transition> 
        </div>

        <!-- 删除好友框 -->
        <div v-show="showMenu"  class="context-menu" :style="{ top: `${menuY}`, left: `${menuX}` }">
          <el-popconfirm
            @confirm="ClickMeToDelFriend"
            confirm-button-text='好的'
            cancel-button-text='不用了'
            icon="el-icon-info"
            icon-color="red"
            title="确定删除当前好友吗？"
          >
            <el-button slot="reference">删除好友</el-button>
          </el-popconfirm>
        
        </div>

        <!-- 添加好友框 -->
        <div class="centered title_state" v-if="openSearch">
          
          <div class="chathead"> 
            <div class="container">
            <div class="row">
              <div class="col-11">
                <i class="el-icon-s-custom" style="font-size: 14px;"> 查找</i> 
              </div>
              <div class="col-1">
                <img @click="openSearch =false" class="img-responsive" style="margin-left: 20px;"
                width="20px" height="20px" src="https://cdn.acwing.com/static/web/img/file_system/gui/window/button/close.png" 
                alt="关闭">
              </div>
            </div>
          </div>
          </div>

          <el-input
            placeholder="请输入内容"
            v-model="input"
            clearable
            @keyup.native.enter="handleEnter">
          </el-input>

          <div class="chatbody">
            <div class="container">
              <div class="row">
                <div class="col-4 chatcontent" v-for="f in searchList" :key="f.id">
                  <img :src="f.photo" alt="" width="40px" height="40px" style="border-radius: 50%;">
                  <span style="margin-left:5px; font-size: 18px;">{{ f.name.substr(0,5) }}</span>
                  <el-button @click="ClickMeToAddFriend(f.id)" type="info" icon="el-icon-message" circle style="display: flex; float:right; margin-top: 6px;"></el-button>
                </div>
              </div>
            </div>

          </div>
        </div>
    </div>
</template>

<script>
    import { 
      constructWss,
      sendConnectRequset,
      sendMessage 
    } from '../ccccchat.js'

    import $ from 'jquery'
    import Chat from '../Chat.vue'
    import 'animate.css'
    export default {
        name:'Navbar',
        components: {
            Chat,
        },
        data (){
          return {
            socket:null,

            activeIndex: '1',
            canClick: true, // 保证聊天的点击1s内只能触发一次
            /* 控制删除好友框的位置 */
            showMenu: false,
            menuX: 0,
            menuY: 0,
            /* 控制聊天框的位置 */
            Right: "calc(50% - 450px)",
            Top: "22%",
            openSearch:false,
            searchList:[], // 搜索用户的列表
            /* 判断是否点击了 聊天框*/
            isdianji:false,
            str:'在线',
            color:'green',
            input: '',
            info:{
            },
            /* 好友信息 */
            friends: [
            ],
            /* 判断是否点击了 添加好友框 */
            openSelect:false,
            ID:'',
            lastId:'', // 上次最后一个聊天人的id是什么
          }
        },
        watch: { //用来监听是否点击到了头像外的框框
        openSelect (val) {
            if (val) {
            document.body.addEventListener('click', () => {
                this.openSelect = false
            })
            } else {
            document.body.removeEventListener('click', () => {})
            }
        },
        friends: {
            immediate:true,//初始化的时候调用一下
            deep:true,
            handler(newvalue,oldvalue) {
                console.log("friends被修改了:新的是" + newvalue + " 旧的是" + oldvalue);
                this.$store.commit('personsabout/ADDPERSONS', newvalue)
            }
        },
        input: {
            deep:true,
            handler(value) {
            const vue = this
            const store = this.$store
            vue.searchList = []
            $.ajax({
                url:"https://app6132.acapp.acwing.com.cn/api/friend/search/",
                type:"post",
                headers: {
                Authorization: "Bearer " + store.state.me.token,
                },
                data: {
                name: value,
                },
                success(resp) {
                if (resp.error_message === "success") {
                    console.log("搜索用户列表成功辣")
                    vue.searchList = JSON.parse(resp.list)
                } else {
                    console.log("搜搜好友失败了, resp ==> ", resp.error_message);
                }
                },
                error(resp) {
                console.log("加好友输错了, resp ==> ", resp)
                }
            })
            }
        }
        },
        directives: { // 自定义指令
        drag(el, bindings) {
            const header = el.querySelector('.header')

            header.onmousedown = function(e) {
            var disx = e.pageX - el.offsetLeft
            var disy = e.pageY - el.offsetTop
            document.onmousemove = function (e) {
                el.style.left = e.pageX - disx + 'px'
                el.style.top = e.pageY - disy + 'px'
            }
            document.onmouseup = function() {
                document.onmousemove = document.onmouseup = null
            }
            }
        }
        },
        mounted() {
          // if (this.$store.state.me.token !== "") this.CreateWebSocket()
          // else {
          //     const t = setInterval(() => {
          //         if (this.$store.state.me.token !== "") {
          //             console.log("我开始hh协议了")
          //             this.CreateWebSocket()
          //             clearInterval(t); // 清除定时器
          //             console.log("我停止了")
          //         }
          //     }, 100);
          // }
        },
        beforeDestroy() {
          // this.socket.close()
        },
        methods: {
          
          handleSelect(key, keyPath) {
            console.log(key, keyPath);
          },
          getFriendInfo(id) { // 获取好友列表
            const store = this.$store
            const vue = this
            $.ajax({
              url:"https://app6132.acapp.acwing.com.cn/api/friend/get/",
              type:"post",
              headers: {
                  Authorization: "Bearer " + store.state.me.token,
              },
              data: {
                id:id,
              },
              success(resp) {
                  if (resp.error_message === "success") {
                    console.log("成功获取到了好友列表")
                    console.log("List == >", JSON.parse(resp.list))
                    vue.friends = JSON.parse(resp.list)
                  } else {
                    console.log("暂无好友");
                  }
              },
              error(resp) {
                console.log("获取好友列表失败, resp ==> ", resp)
              }
            })
          },
          ClickMeToDelFriend() { // 按照id删除好友 ID是已经记录好点击的好友id
            console.log("要删除咯")
            const store = this.$store
            const vue = this
            $.ajax({
              url:"https://app6132.acapp.acwing.com.cn/api/friend/delete/",
              type:"post",
              headers: {
                  Authorization: "Bearer " + store.state.me.token,
              },
              data: {
                id:vue.ID,
              },
              success(resp) {
                  if (resp.error_message === "success") {
                    vue.getFriendInfo(store.state.me.id)
                    console.log("删除成功咯")
                  } else {
                    console.log("删除失败了, == >", resp.error_message);
                  }
              },
              error(resp) {
                console.log("删除好友彻底失败了, resp ==> ", resp)
              }
            })
          },
          showContextMenu(event, id) {
            event.preventDefault(); // 阻止默认右键菜单
            this.showMenu = true; // 显示自定义右键菜单
            this.menuX = event.pageX + "px"; // 获取鼠标点击位置的X坐标
            this.menuY = event.pageY + "px"; // 获取鼠标点击位置的Y坐标

            // 点击页面其他地方隐藏右键菜单
            window.addEventListener('click', this.hideContextMenu);

            this.ID = id // 说明当前困难删除这个好友id
          },
          hideContextMenu() {
            this.showMenu = false; // 隐藏右键菜单
            console.log("show? ", this.showMenu)
            window.removeEventListener('click', this.hideContextMenu);
          },
          ClickMeToAddFriend(id) { // 添加好友
          const store = this.$store
          const vue = this
          $.ajax({
              url:"https://app6132.acapp.acwing.com.cn/api/friend/add/",
              type:"post",
              headers: {
                  Authorization: "Bearer " + store.state.me.token,
              },
              data: {
                  id:id,
              },
              success(resp) {
                  if (resp.error_message === "success") {
                      console.log("添加成功了")
                      vue.getFriendInfo(store.state.me.id) // 更新好友信息
                  } else {
                      console.log("resp == >", resp.error_message);
                  }
              },
              error(resp) {
                  console.log("添加好友失败, resp ==> ", resp)
              }
              })
          },
          UpdateInfo() { //修改个人信息页面
              if (this.$route.path !== '/MyInfomation/info' && this.$route.path !== '/MyInfomation/competeexpence' && this.$route.path !== '/MyInfomation')
              this.$router.push('/MyInfomation')
          },
          OutLogin() { // 退出登录        
              const store = this.$store
              store.dispatch('logout')
              if(this.$route.path !== "/function")
              this.$router.push('/function')
          },
          handleEnter() { // 搜索好友
              const vue = this
              const store = this.$store
              vue.searchList = []
              console.log("input ==>", vue.input)
              $.ajax({
                url:"https://app6132.acapp.acwing.com.cn/api/friend/search/",
                type:"post",
                headers: {
                    Authorization: "Bearer " + store.state.me.token,
                },
                data: {
                    name: vue.input,
                },
                success(resp) {
                    if (resp.error_message === "success") {
                        // console.log("搜索好友成功了, resp == >", resp)
                        console.log("list == >", JSON.parse(resp.list));
                        vue.searchList = JSON.parse(resp.list)
                    } else {
                        console.log("搜搜好友失败了, resp ==> ", resp.error_message);
                    }
                },
                error(resp) {
                    console.log("加好友输错了, resp ==> ", resp)
                }
              })
          },
          dianwol(f) {
              this.info = f
              /* 说明是点了其他框框 那么此时清空数据 在这里的时候 两个id还是不一样的*/
              // console.log("lastId", this.$refs.SonComponent.lastId)
              if (f.id !== this.$refs.SonComponent.lastId)
              {
                  // sendConnectRequset(f.id)
                  this.$refs.SonComponent.lastId = f.id
                  this.$refs.SonComponent.lastPhoto = f.photo
                  this.$refs.SonComponent.del()
                  this.$refs.SonComponent.ReadFriendMessage()
                  // console.log(this.$refs.SonComponent.lastId)
                  // console.log("接收者id为：",f.id)
              }
              // console.log("f.id = ", f.id , "f.name = ", f.name)
              // const chat = new MultiChat();
              // const vue = this;
              // chat.connect_chat_user(vue.$store.state.username);
          },
          dianji() { // 打开AL Chat
              const store = this.$store

              if (!store.state.me.is_login) {
                this.$notify({
                  title: '通知：',
                  message: '请先登录',
                });
                return ;
              }

              this.getFriendInfo(store.state.me.id)
              this.isdianji = !this.isdianji
              if(this.isdianji === true) {
                // const chatBox = this.$refs.SonComponent.chatBox

                // constructWss(this.$store.state.me.id, this.$store.state.me.photo, chatBox)
                // console.log("打开了AL Chat")
              }
              else {
                this.openSearch = false
                // console.log("关闭了AL Chat")
              }
          },
          dianwo() { // 改变在线状态
            if(this.str === '在线') {
                this.str = '离线'
                this.color = 'red'
            }
            else {
                this.str = '在线'
                this.color = 'green'
            }
          },
        }
    }
</script>

<style scoped>
.hoverhover:hover{
  background-color: lightblue;
}
.InfoAndOutLogin { /* 点头像后出现的框框的样式 */
  width: 100px; 
  height: 100px; 
  background-color: white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04)
}
.friendslan:hover {
  background-color: rgb(188, 233, 248);
}
  .al-chat {
      position: fixed;
      display: flex;
      width:900px;
      height: 35px;
      font-size:20px ;
  }
  /* 整个导航的样式 */
  .homepage-header {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 101;
    width: 100%;
    height: auto;
    line-height: 42px;
    background-color: #FFFFFF;
    box-shadow: 0 0 15px rgba(96,96,96,.2);
    display: flex;
  }
  
  /* 路由默认和激活样式 */

  /* 聊天框内的东西 */
  .chat_window1 {
      box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
      width: 900px;
      height: 450px;
      position: fixed;
      display: flex;
      z-index: 20;
      background-color: #F5F5F5;
      border: 1px solid lightgrey;
  }

  /* 好友页的样式 */
.ma {
    position: relative;
    display: flex;
    width: 100%;
    height: 100%;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    /* filter: blur(3px); */
}
.relative {
    position: relative;
}
.chat {
    display: none;
    position: relative;
    height: 100%;
    background-color: black;
}
/*聊天气泡*/
.message {
    background-color: #0074a4;
    border-radius: 10px;
    flex-direction: column;
    /* 将元素竖向排列 */
    float: right;
    max-width: calc(80% - 5vh - 1vh - 1vh);
    height: auto;
    word-break: break-all;
    padding: 1vh;
    margin-right: 1vh;
    border-radius: 3px;
    overflow: hidden;
    font-size: 2vh;
}
p {
    width: 100%;
    font-size: 28px;
    font-weight: bold;
    font-style: italic;
    text-align: center;
}
.center {
    display: flex;
    align-items: center;
    justify-content: center;
}
.context-menu {
  font-size: 12px;
  position: absolute;
  z-index: 20;
}
.title_state {
  overflow: auto; 
}
/* 下面都是滚动条样式 */
.title_state::-webkit-scrollbar {
  width:5px;
  height:10px;
}
.title_state::-webkit-scrollbar-thumb {
  background-color:skyblue;
  height:50px;
  outline-offset:-2px;
  outline:2px solid #fff;
  -webkit-border-radius:4px;
  border: 2px solid #fff;
}
.title_state::-webkit-scrollbar-thumb:hover {
  background-color:#999999;
  height:50px;
  -webkit-border-radius:4px;
}
.title_state::-webkit-scrollbar-piece {
  background-color:#fff;
  -webkit-border-radius:0;
}
.chatcontent {
  height: 50px;
  line-height: 50px;
}
.chatbody {
  padding: 10px;
  overflow: auto;
}
.chathead {
  display: flex;
  padding-left: 10px;
  height: 20px;
  line-height: 20px;
  background-color: #F5F5F5;
  /* justify-content: center; */
  align-content: center;
  align-items: center;
}
.centered {
  position: fixed;
  top: 50%; /* 将内容的顶部定位在视口的中间 */
  left: 50%; /* 将内容的左侧定位在视口的中间 */
  transform: translate(-50%, -50%); /* 通过transform属性将内容向左上角移动它自身宽度和高度的一半 */
  /* 可以添加其他样式，比如宽度、高度、背景色等 */
  background-color: white;
  width: 600px;
  height: 300px;
  z-index: 100;
  border: 1px solid lightgrey;
  overflow: auto;
}
.homepage-header {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 101;
    width: 100%;
    height: auto;
    line-height: 42px;
    background-color: #FFFFFF;
    box-shadow: 0 0 15px rgba(96,96,96,.2);
  }
.daohanga {
  border-bottom: 3px solid #1EBF9B;
  box-sizing: border-box; /* 使用 border-box 盒模型 */
}
.daohangb {
  width: 100px;
  box-sizing: border-box; /* 使用 border-box 盒模型 */
  font-size: 15px;
  text-decoration: none;
  color: #666666;
}
</style>